// API
import { ApolloError } from "@apollo/client";
import { useGetBatchByIdQuery, BatchPropertiesFragment, SingleGroupFragmentFragment } from "generated/graphql";

// Utils
import { getBUFromLocalStorage } from "helpers/storage";

export type Batch = BatchPropertiesFragment & SingleGroupFragmentFragment;

type UseGetBatchByIdReturn = {
  data: Batch;
  loading: boolean;
  error: ApolloError | undefined;
};

export const useGetBatchById = (groupId: string): UseGetBatchByIdReturn => {
  const { data, loading, error } = useGetBatchByIdQuery({
    variables: {
      group: groupId,
      businessUnit: getBUFromLocalStorage(),
    },
    skip: !groupId,
    fetchPolicy: "cache-and-network",
    nextFetchPolicy: "cache-only",
  });

  const batch = (data?.group as Batch) || null;

  return { data: batch, loading, error };
};
